<!-- 新生报到 -->
<template>
    <div class="el-studentReport">
        <el-row class="page_content">

            <h1 class="head_title">
                新生报到
                <span
                    v-if="!$isEmpty(registrationTime.startTime) && !$isEmpty(registrationTime.endTime) && !$strExistHostnameOnce(['hbkjxy'])"
                    style="font-size: 14px;color: #ff2626;margin-left: 20px;font-weight: 500;">
                    【 报到时间：{{ registrationTime.startTime }} 至 {{ registrationTime.endTime }} 请在规定时间内完成报到！】
                </span>
            </h1>
            <template v-if="$isEmpty(registrationTime.startTime) || $isEmpty(registrationTime.endTime)">
                <el-empty :description="descriptionMsg"></el-empty>
            </template>
            <template v-if="!$isEmpty(registrationTime.startTime) && !$isEmpty(registrationTime.endTime)">
                <el-steps v-if="showSteps" :active="active" align-center finish-status="success"
                    style="width: 1000px;margin: 0 auto;">
                    <el-step title="缴费" v-if="setUpInfo.studentNewPayConfig"></el-step>
                    <el-step title="确认信息"></el-step>
                    <el-step title="照片上传" v-if="setUpInfo.studentNewPhotoOpenConfig"></el-step>
                    <el-step title="人脸识别" v-if="setUpInfo.studentNewFaceOpenConfig"></el-step>
                    <el-step title="报到材料补充" v-if="setUpInfo.studentNewDataOpenConfig"></el-step>
                    <el-step title="报道材料审核状态" v-if="setUpInfo.studentNewDataAuditOpenConfig"></el-step>
                    <el-step title="报到完成"></el-step>
                </el-steps>
                <!-- <p style="color: red;text-align: center;margin: 0;">
                报到时间：2023-10-11 至 2023-12-11 请在规定时间内完成报到！
            </p> -->
                <el-row style="margin-top: 10px;">
                    <!-- 步骤1 -->
                    <div v-if="flowMap[active] == 'payConfig'" style="width: 500px;margin: 0 auto;">
                        <template v-if="payStatusInfo.payStatus == 2">
                            <!-- <h2 class="studentName">{{ userInfo.studentName }}</h2> -->
                            <!-- <p>函授站：{{ userInfo.corSchoolName  || "-"}}</p> -->
                            <p>姓名：{{ userInfo.studentName }}</p>
                            <p v-if="payStatusInfo.payType == 1">待缴费：<span style="color:red">￥ {{ toBePaid }}</span></p>
                            <template v-if="!$strExistHostnameOnce(['hsnc'])">
                                <p>身份证号：{{ userInfo.studentIdCard || "-" }}</p>
                            </template>
                            <template v-else>
                                <p>学号：{{ userInfo.studentNo || "-" }}</p>
                            </template>

                            <el-button type="primary" v-if="payStatusInfo.payType == 1"
                                @click="payDialogClick">去支付</el-button>
                            <el-row style="color: red;">
                                {{ payStatusInfo.payMsg }}
                            </el-row>
                        </template>
                        <template v-if="payStatusInfo.payStatus == 1">
                            <p style="color: #67C23A;text-align: center;">
                                <i class="el-icon-success"
                                    style="font-size: 60px;display: block;margin-bottom: 20px;"></i>
                                {{ payStatusInfo.payMsg }}
                            </p>
                            <el-row style="text-align: center;">
                                <el-button type="primary" @click="next" :loading="nextButtonLoading" style="margin-top: 80px;">下一步</el-button>
                            </el-row>
                        </template>
                    </div>
                    <!-- 步骤2 -->
                    <div v-if="flowMap[active] == 'confirmConfig'" style="width: 1000px;margin: 0 auto;">
                        <template v-if="!$isEmpty(userInfo.studentName)">
                            <el-descriptions :colon="false" :column="2">
                                <el-descriptions-item label="姓名：">{{ userInfo.studentName }}</el-descriptions-item>
                                <el-descriptions-item label="考生号：">{{ userInfo.studentTestNo }}</el-descriptions-item>
                            </el-descriptions>
                            <el-descriptions :colon="false" :column="2">
                                <template v-if="!$strExistHostnameOnce(['hsnc'])">
                                    <el-descriptions-item label="身份证号：">{{ userInfo.studentIdCard }}
                                    </el-descriptions-item>
                                </template>
                                <template v-else>
                                    <el-descriptions-item label="学号：">{{ userInfo.studentNo }} </el-descriptions-item>
                                </template>
                                <el-descriptions-item label="性别：">{{ userInfo.studentSex == 1 ? "男" :
                                    userInfo.studentSex ==
                                        2 ? "女" : "保密" }}</el-descriptions-item>
                            </el-descriptions>
                            <!-- <template v-if="!$strExistHostnameOnce(['hsnc','hbwgy'])">
                            <el-descriptions :colon="false" :column="2">
                                <el-descriptions-item label="政治面貌：">{{userInfo.studentPoliticalOutlook}}</el-descriptions-item>
                              <el-descriptions-item label="民族：">{{userInfo.studentNation}}</el-descriptions-item>
                            </el-descriptions>
                        </template> -->
                            <el-descriptions :colon="false" :column="2">
                                <el-descriptions-item label="专业名称：">{{ userInfo.professionalName
                                    }}</el-descriptions-item>
                                <el-descriptions-item label="层次：">{{ userInfo.cultivationLevelConcat
                                    }}</el-descriptions-item>
                            </el-descriptions>
                            <el-descriptions :colon="false" :column="2">
                                <el-descriptions-item label="学习形式：">{{ userInfo.learningModalityConcat
                                    }}</el-descriptions-item>
                                <template v-if="!$strExistHostnameOnce(['hsnc', 'hbwgy', 'localhost'])">
                                    <el-descriptions-item label="学制：">{{ userInfo.professionalLength
                                        }}</el-descriptions-item>
                                </template>
                            </el-descriptions>

                            <el-row style="text-align: center;">
                                <!--1：已确认 2：待确认 3：信息有误  -->
                                <template v-if="!$strExistHostnameOnce(['hsnc', 'hbwgy', 'localhost','hevttc','nciae','lfsfxy'])">
                                    <el-button type="primary" style="margin-top: 12px;"
                                        v-if="userInfo.studentConfirm == 1" @click="next" :loading="nextButtonLoading">下一步</el-button>
                                    <el-button type="primary" v-if="userInfo.studentConfirm == 2" :loading="submitBut"
                                        style="margin-top: 20px;" @click="submitInfo(1)">确认无误</el-button>
                                    <!-- @click="infoConfirm" -->
                                    <el-button type="danger" v-if="userInfo.studentConfirm == 2" :loading="submitBut"
                                        style="margin-top: 20px;" @click="infoConfirm">信息有误</el-button>
                                    <el-button type="danger" plain v-if="userInfo.studentConfirm == 3"
                                        style="margin-top: 20px;">已确认信息有误</el-button>
                                </template>
                                <template v-else>
                                    <el-button type="primary" style="margin-top: 12px;"
                                        v-if="userInfo.studentConfirm == 2 || userInfo.studentConfirm == 3" :loading="submitBut"
                                        @click="submitInfo(1, 'xyb')">下一步</el-button>
                                    <el-button type="primary" style="margin-top: 12px;"
                                        v-if="userInfo.studentConfirm == 1" @click="next" :loading="nextButtonLoading">下一步</el-button>
                                </template>
                            </el-row>
                        </template>
                    </div>
                    <el-dialog title="提示" :visible.sync="infoConfirmVisible" width="30%" style="margin-top: 100px;"
                        :close-on-click-modal="false">
                        <div class="infoConfirmText">如果信息有误，请联系平台老师18618337286</div>
                        <span slot="footer" class="dialog-footer">
                            <el-button type="primary" @click="submitInfo(3)">确 定</el-button>
                        </span>
                    </el-dialog>
                    <!-- 步骤3 -->
                    <div v-if="flowMap[active] == 'dataOpenConfig'" style="width: 1000px;margin: 0 auto;">
                        <el-row style="padding-bottom:10px;">
                            <el-col :span="4" style="text-align: center;min-width:200px;">
                                新生照片预览
                            </el-col>
                            <el-col :span="4" style="min-width:200px;text-align: center;">
                                新生照片上传
                            </el-col>
                        </el-row>
                        <el-row style="padding-bottom:10px;">
                            <el-col :span="4" style="text-align: center;min-width:200px;">
                                <el-image :src="headImg" :preview-src-list="[headImg]"
                                    style="border: 1px solid #f0f0f0;width: 144px;height: 192px;" />
                            </el-col>
                            <el-col :span="4" style="min-width:200px;text-align: center;">
                                <el-upload class="avatar-uploader" :action="uploadUrl"
                                    :disabled="studentPhotoInfo.studentPhotoConfirm == 1" :headers="headers"
                                    :show-file-list="false" :on-success="handleAvatarSuccess"
                                    :before-upload="beforeAvatarUpload">
                                    <i class="el-icon-plus avatar-uploader-icon" title="点击上传"></i>
                                </el-upload>
                            </el-col>

                            <el-col :span="14" style="min-width:300px;">
                                <!-- studentPhotoConfirm:是否确认照片无误（1是 2否） -->
                                <!-- studentStatusState:状态（1已审核 2未审核 3不通过） -->
                                <p v-if='studentPhotoUrl != null && studentPhotoUrl != ""'>
                                    照片状态：
                                    <template
                                        v-if="studentPhotoInfo.studentPhotoConfirm == 2 || studentPhotoInfo.studentPhotoConfirm == null">
                                        <span style="color: #b0adad;">未确认</span>
                                        <el-button style="margin-left: 20px;" @click="confirmStudentNewPhoto"
                                            size="small" type="primary">确认照片</el-button>
                                    </template>
                                    <template v-else>
                                        <span style="color: #3967FF;"
                                            v-if="studentPhotoInfo.studentPhotoConfirm == 1">已确认无误</span>
                                    </template>
                                </p>
                                <template v-if="studentPhotoInfo.studentPhotoState != null">
                                    <p>
                                        审核状态：
                                        <span style="color: #3967FF;"
                                            v-if="studentPhotoInfo.studentPhotoState == 1">审核通过</span>
                                        <span style="color: #b0adad;"
                                            v-if="studentPhotoInfo.studentPhotoState == 2">待审核</span>
                                        <span style="color: red;"
                                            v-if="studentPhotoInfo.studentPhotoState == 3">审核未通过（请重新上传）</span>
                                    </p>
                                    <div style="color: red;"
                                        v-if="studentPhotoInfo.studentPhotoState == 3 && !$isEmpty(studentPhotoInfo.examineRemark)">
                                        审核说明：{{ studentPhotoInfo.examineRemark }}
                                    </div>
                                </template>
                            </el-col>
                        </el-row>
                        <el-row style="color:red;padding-left:50px;font-size: 12px;">
                            <p style="margin:0;">电子版图像要求：</p>
                            <p style="margin:5px  0;">1、蓝色背景，图像不大于1M；</p>
                            <p style="margin:5px  0;">2、图像“高”要求在 192 像素（px），“宽”要求在 144 像素（px）；</p>
                            <p style="margin:5px  0;">3、鉴于学生照片的严肃性，请同学务必提交标准证件照，生活照、手机拍照、以及PS、美图等工具修复的照片均不予审核通过。</p>
                        </el-row>

                        <el-row style="text-align: center;margin-top: 12px;">
                            <!-- <el-button type="primary" v-if="$isEmpty(studentPhotoUrl)" @click="addStudentNewPhoto">确认上传</el-button> -->
                            <!-- <el-button type="primary" @click="confirmStudentNewPhoto">确认无误</el-button> -->
                            <el-button type="primary" @click="next" :loading="nextButtonLoading"
                                v-if="studentPhotoInfo.studentPhotoState == 1">下一步</el-button>
                        </el-row>
                    </div>
                    <!-- 步骤5 人脸识别 -->
                    <div v-if="flowMap[active] == 'faceOpenConfig'"
                        style="width: 1000px;margin: 0 auto;text-align: center;">
                        <!-- 短信验证（在人脸识别步骤中，根据条件显示） -->
                        <div v-if="needShowSmsVerify" style="width: 500px;margin: 0 auto 50px;">
                            <!-- 顶部提示文字 -->
                            <p style="text-align: left;color: #606266;margin-bottom: 20px;line-height: 1.6;">
                                各位同学,人脸核验后,匹配度不达标的请在"上传身份证明"处上传身份证等相关图片。
                            </p>
                            <el-form :model="smsForm" :rules="smsRules" ref="smsForm" label-width="100px" style="margin-top: 20px;">
                                <el-form-item label="手机号码:" prop="studentPhone" required style="text-align: left;">
                                    <el-input v-model="smsForm.studentPhone" placeholder="请输入手机号" style="width: 326px;"></el-input>
                                </el-form-item>
                                <el-form-item label="验证码:" prop="yzm" v-if="phoneNeedSendSms" style="text-align: left;">
                                    <el-input placeholder="请输入验证码" v-model="smsForm.yzm" style="width: 200px;display: inline-block;">
                                    </el-input>
                                    <el-button type="primary" style="margin-left: 10px;" :disabled="disabledBut" @click="getYzm">{{setCode}}</el-button>
                                </el-form-item>
                            </el-form>
                            <!-- 系统声明 -->
                            <div style="text-align: left;margin-top: 30px;margin-bottom: 20px;">
                                <p style="color: #606266;margin-bottom: 10px;">系统声明:</p>
                                <p style="color: #909399;line-height: 1.6;">进行人脸识别需要开启您的摄像头,请确认同意</p>
                            </div>
                            <!-- 同意复选框 -->
                            <el-checkbox v-model="agreeCamera" style="margin-bottom: 30px;">我已阅读并同意</el-checkbox>
                            <!-- 开始核验按钮 -->
                            <el-row style="text-align: center;">
                                <el-button type="primary" @click="submitSmsInfo" :loading="smsSubmitBut" :disabled="!agreeCamera"
                                    style="width: 100%;height: 45px;font-size: 16px;">开始核验</el-button>
                            </el-row>
                        </div>
                        <template v-if="showFace == 1">
                            <p style="color: #67C23A;">
                                <i class="el-icon-success"
                                    style="font-size: 60px;display: block;margin-bottom: 20px;"></i>
                                已通过人脸识别
                            </p>
                            <el-button type="primary" @click="next" :loading="nextButtonLoading" style="margin-top: 80px;">下一步</el-button>
                        </template>
                        <template v-else>
                            <!-- 人脸识别失败界面 -->
                            <div v-if="faceVerifyFailed" style="width: 800px;margin: 0 auto;">
                                <el-row style="display: flex;justify-content: space-around;margin-bottom: 30px;">
                                    <div style="text-align: center;">
                                        <p style="margin-bottom: 10px;font-weight: bold;">录取照片</p>
                                        <el-image
                                            :src="faceFailInfo.originalImage || headImg"
                                            style="width: 200px;height: 250px;border: 1px solid #e4e7ed;"
                                            fit="cover">
                                        </el-image>
                                    </div>
                                    <div style="text-align: center;">
                                        <p style="margin-bottom: 10px;font-weight: bold;">采集图像</p>
                                        <el-image
                                            v-if="faceFailInfo.capturedImage"
                                            :src="$isHttp(faceFailInfo.capturedImage)"
                                            style="width: 200px;height: 250px;border: 1px solid #e4e7ed;"
                                            fit="cover">
                                        </el-image>
                                        <div v-else style="width: 200px;height: 250px;border: 1px solid #e4e7ed;display: flex;align-items: center;justify-content: center;background-color: #f5f7fa;">
                                            <span style="color: #909399;">暂无图像</span>
                                        </div>
                                    </div>
                                </el-row>
                                <el-row style="text-align: center;margin-bottom: 20px;">
                                    <i class="el-icon-circle-close" style="font-size: 60px;color: #F56C6C;"></i>
                                </el-row>
                                <el-row style="text-align: center;margin-bottom: 20px;" v-if="faceFailInfo.similarity !== '' && faceFailInfo.similarity !== null && faceFailInfo.similarity !== undefined">
                                    <div style="display: inline-block;padding: 10px 20px;border: 2px solid #F56C6C;border-radius: 4px;">
                                        <span style="color: #F56C6C;font-size: 16px;font-weight: bold;">
                                            匹配度:{{ faceFailInfo.similarity }}%
                                        </span>
                                    </div>
                                </el-row>
                                <el-row style="text-align: center;margin-bottom: 30px;color: #606266;line-height: 1.6;">
                                    <p>匹配度不达标,可重新核验,仍未审核通过,可上传身份证明</p>
                                </el-row>
                                <el-row style="text-align: center;">
                                    <el-button type="primary" @click="reVerifyFace" style="margin-right: 20px;width: 150px;">重新核验</el-button>
                                    <el-button @click="uploadIdentityProof" style="width: 150px;">上传身份证明</el-button>
                                </el-row>
                            </div>
                            <!-- 人脸识别 -->
                            <template v-else-if="getTimeRegion(1)">
                                <newStudentFace
                                    v-if="visibleFaceModal && showFace != 1 && !needShowSmsVerify"
                                    v-show="visibleFaceModal"
                                    :headImg="headImg"
                                    @successFace="successFace"
                                    @faceFailed="handleFaceFailed"
                                    :visible="visibleFaceModal" />
                            </template>
                            <template v-else>
                                <p style="color: red;margin-top: 50px;">
                                    <i class="el-icon-error"
                                        style="font-size: 60px;display: block;margin-bottom: 20px;"></i>
                                    报道时间已结束
                                </p>
                            </template>
                        </template>
                    </div>
                    <!-- 步骤6 -->
                    <div v-if="flowMap[active] == 'photoOpenConfig'" style="width: 900px;margin: 0 auto;">
                        <template v-for="(item, index) in attributeList">
                            <div
                                style="margin-bottom: 20px;border: 1px solid rgb(230 230 231);padding: 20px;box-shadow: 1px 2px 4px rgb(230 230 231);border-radius: 10px;">
                                <el-row style="padding-bottom:20px;" :key="index + 'attributeList'">
                                    <span class="title_l">
                                        <span style="color:red;" v-if="item.notNullStatus == 1">*</span>
                                        {{ item.attributeName }}：
                                    </span>
                                    <span style="float:left;margin-right:20px;"
                                        v-if="item.inputType == 6 || item.inputType == 5">
                                        <el-upload class="avatar-uploader" :action="uploadUrl" :headers="headers"
                                            :show-file-list="false"
                                            :on-success="(res, file) => { attributeSuccess(item, res, file) }"
                                            :disabled="showBut == 3"
                                            :before-upload="item.inputType == 5 ? beforeAvatarUpload : null">
                                            <template v-if="item.inputType == 5">
                                                <img v-if="!$isEmpty(attributeRelationMap[item.attributeId])"
                                                    :src="$isHttp(attributeRelationMap[item.attributeId])"
                                                    class="attrList_avatar">
                                            </template>
                                            <template v-if="item.inputType == 6">

                                                <img v-if="!$isEmpty(attributeRelationMap[item.attributeId])"
                                                    :src="filePng" class="attrList_avatar">
                                            </template>
                                            <i v-if="$isEmpty(attributeRelationMap[item.attributeId])"
                                                class="el-icon-plus attrList-uploader-icon" title="点击上传"></i>
                                        </el-upload>
                                    </span>
                                    <!-- 签名 -->
                                    <span style="float:left;margin-right:20px;" v-if="item.inputType == 9">
                                        <div style="border: 1px dashed #d9d9d9;width: 200px;height: 100px;">
                                            <img v-if="!$isEmpty(attributeRelationMap[item.attributeId])"
                                                :src="$isHttp(attributeRelationMap[item.attributeId])"
                                                class="attrList_avatar">
                                        </div>
                                    </span>
                                    <span style="float:left;margin-right:20px;">
                                        <el-button type="primary" size="small"
                                            @click="previewImg(attributeRelationMap[item.attributeId])"
                                            v-if="!$isEmpty(attributeRelationMap[item.attributeId]) && (item.inputType == 5 || item.inputType == 9)">预览</el-button>
                                        <el-button type="success" size="small"
                                            @click="cropper_cj(attributeRelationMap[item.attributeId], item.attributeId)"
                                            v-if="!$isEmpty(attributeRelationMap[item.attributeId]) && item.inputType == 5">裁剪</el-button>
                                        <el-button type="primary" size="small"
                                            @click="$downLoadFile(attributeRelationMap[item.attributeId], item.attributeName + '附件')"
                                            v-if="!$isEmpty(attributeRelationMap[item.attributeId]) && item.inputType == 6">下载</el-button>
                                        <el-button type="primary" size="small"
                                            @click="singShow(attributeRelationMap[item.attributeId], item.attributeId)"
                                            v-if="item.inputType == 9">立即签名</el-button>
                                    </span>
                                </el-row>
                                <el-row>
                                    <span class="title_l">
                                        描述：
                                    </span>
                                    <span style="float:left;margin-right:20px;width: 550px;color: #8c939d;">
                                        {{ item.attributeValues }}
                                    </span>
                                </el-row>
                            </div>
                        </template>
                        <div style="text-align: center;">
                            <el-button type="primary" style="margin-top: 12px;" v-if="showBut == 1"
                                @click="saveStudentNewData">提交资料</el-button>
                            <el-button type="primary" style="margin-top: 12px;" v-if="showBut == 2"
                                @click="saveStudentNewData('qrwu')">确认无误</el-button>
                            <!-- <template v-if="studentNewDataState == 1">
                            <el-button type="primary" style="margin-top: 12px;" v-if="showBut == 3" @click="next"  :loading="nextButtonLoading">下一步</el-button>
                        </template>
                        <template v-if="studentNewDataState == 2 && studentConfirmStatus == 1">
                            <el-button type="primary" plain style="margin-top: 12px;">材料已确认，等待审核中</el-button>
                        </template>
                        <template v-if="studentNewDataState == 3">
                            <span style="color: red;">审核未通过请重新上传</span>
                        </template> -->
                            <el-button type="primary" style="margin-top: 12px;" v-if="showBut == 3"
                                @click="next"  :loading="nextButtonLoading">下一步</el-button>
                        </div>
                    </div>
                    <!-- 步骤7 -->
                    <div v-if="flowMap[active] == 'auditPhotoOpenConfig'" style="width: 900px;margin: 0 auto;">
                        <div style="text-align: center;">
                            <template v-if="studentNewDataState == 1">
                                <p style="color: #67C23A;margin-top: 100px;">
                                    <i class="el-icon-success"
                                        style="font-size: 60px;display: block;margin-bottom: 20px;"></i>
                                    资料审核通过
                                </p>
                                <el-button type="primary" style="margin-top: 12px;" @click="next" :loading="nextButtonLoading">下一步</el-button>
                                <!-- <div style="background-color: #f4f4f4;border-radius:5px;margin-top: 50px;" v-if="examineRemark != null && examineRemark != ''">
                                   <p style="text-align: left;color: red;margin: 0px auto;padding: 10px 20px;min-height: 60px;"> 审核说明：{{examineRemark}}</p>
                               </div> -->
                            </template>
                            <template v-if="studentNewDataState == 2 && studentConfirmStatus == 1">
                                <p style="color: #b1b1b1;margin-top: 100px;">
                                    <i class="el-icon-time"
                                        style="font-size: 60px;display: block;margin-bottom: 20px;"></i>
                                    材料已确认，等待审核中
                                </p>
                            </template>
                            <template v-if="studentNewDataState == 3">
                                <p style="color: red;margin-top: 100px;">
                                    <i class="el-icon-circle-close"
                                        style="font-size: 60px;display: block;margin-bottom: 20px;"></i>
                                    <span style="color: red;">审核未通过请重新上传</span>
                                </p>
                                <el-button type="primary" style="margin-top: 12px;"
                                    @click="previousStep">重新上传</el-button>
                                <div style="background-color: #f4f4f4;border-radius:5px;margin-top: 50px;">
                                    <p
                                        style="text-align: left;color: red;margin: 0px auto;padding: 10px 20px;min-height: 60px;">
                                        审核说明：{{ examineRemark }}</p>
                                </div>
                            </template>
                        </div>
                    </div>
                    <!-- 步骤8 -->
                    <div v-if="flowMap[active] == 'complete'" style="width: 1000px;margin: 0 auto;text-align: center;">
                        <p style="color: #67C23A;margin-top: 100px;" v-if="reportStatus == 1">
                            <i class="el-icon-success" style="font-size: 60px;display: block;margin-bottom: 20px;"></i>
                            新生报到完成
                        </p>
                        <div v-if="reportStatus == 2" style="margin-top: 100px;">
                            <p style="color: #67C23A;margin-bottom: 40px;">个人信息确认无误，请确认报到。</p>
                            <el-button type="primary" style="margin-top: 12px;" @click="confirmReport">确认报到</el-button>
                        </div>
                    </div>
                </el-row>
            </template>

        </el-row>

        <el-dialog title="" :visible.sync="previewImgShow" :show-close="false" class="previewImg" width="500px"
            :before-close="handleClose">
            <img :src="$isHttp(previewImgUrl)" style="max-width: 100%;" />
            <span slot="footer" class="dialog-footer" style="display: none;">
                <el-button @click="previewImgShow = false">取 消</el-button>
                <el-button type="primary" @click="previewImgShow = false">确 定</el-button>
            </span>
        </el-dialog>

        <el-dialog :title="pay_dialog.title" :visible.sync="pay_dialog.visible" class="payDialog" width="600px">
            <el-row>
                <el-col :offset="2">
                    <span class="spanTitle">支付金额</span>
                    <span class="money">￥{{ toBePaid }}</span>
                </el-col>
            </el-row>
            <el-row>
                <el-col :offset="2">
                    <span class="spanTitle">支付订单号</span>
                    <span>{{ payId }}</span>
                </el-col>
            </el-row>
            <el-row>
                <el-col :offset="2">
                    <div class="typeBox">
                        <span class="spanTitle">支付方式</span>
                        <img src="../../assets/wechat.png" alt=""
                            :class="pay_dialog.payType == 'wechat' ? 'selected' : ''" @click="changePayType('wechat')">
                        <!-- <img src="../../assets/alipay.png" alt="" :class="pay_dialog.payType == 'alipay' ? 'selected' : ''"
                            @click="changePayType('alipay')"> -->
                    </div>
                </el-col>
            </el-row>
            <el-dialog width="500px" :visible.sync="pay_dialog.inner_dialog.visible" append-to-body
                class="payInnerDialog">
                <div slot="title" class="dialog-title" style="display: flex;align-items: center">
                    <img :src="pay_dialog.payType === 'wechat' ? require('../../assets/wechat.png') : require('../../assets/alipay.png')"
                        alt="">
                    <span style="margin-left: 1em">{{ pay_dialog.inner_dialog.title }}</span>
                </div>
                <div v-if="pay_dialog.payType === 'wechat'" id="qrcode" ref="qrcode"
                    style="border: none;margin-left: 50%;transform: translateX(-50%)"></div>
                <iframe v-else :src="pay_dialog.inner_dialog.imgSrc" width="200px" height="210px"
                    style="border: none;margin-left: 50%;transform: translateX(-50%)"></iframe>
                <p class="tip" style="color:red;text-align: center;padding-bottom: 20px;">请使用微信App扫码支付 ￥{{ toBePaid }}</p>
            </el-dialog>
            <div slot="footer" class="dialog-footer" align="center">
                <el-button @click="pay_dialog.visible = false">关 闭</el-button>
                <el-button type="primary" @click="goPay">立即支付</el-button>
            </div>
        </el-dialog>
        <!-- 截图 -->
        <Cropper :initialImg="imageUrl" v-if="cropperShow" :key="onDataTime" :isShow="cropperShow"
            @retUrl="getPropsUrl" />

        <!-- 签名 -->
        <singDiv v-if="visible_sign" :visible="visible_sign" @closeMsg="closeMsg" @signValue="saveSignValue"></singDiv>

        <!-- 上传身份证明对话框 -->
        <el-dialog
            title="上传身份证明"
            :visible.sync="identityProofDialogVisible"
            width="600px"
            :close-on-click-modal="false">
            <!-- 说明内容 -->
            <div v-if="identityDocumentExplain" style="margin-bottom: 20px;padding: 15px;background-color: #f5f7fa;border-radius: 4px;">
                <div style="white-space: pre-line;">{{identityDocumentExplain}}</div>
            </div>
            <!-- 审核状态显示 -->
            <div v-if="proofInfo.proofUploadStatus == 1" style="margin-bottom: 20px;padding: 15px;background-color: #f0f9ff;border-radius: 4px;border-left: 4px solid #409EFF;">
                <el-row style="margin-bottom: 10px;">
                    <span style="font-weight: bold;">审核状态：</span>
                    <el-tag v-if="proofInfo.proofAuditStatus == 0" type="info" size="small" style="margin-left: 10px;">未审核</el-tag>
                    <el-tag v-if="proofInfo.proofAuditStatus == 1" type="success" size="small" style="margin-left: 10px;">审核通过</el-tag>
                    <el-tag v-if="proofInfo.proofAuditStatus == 2" type="danger" size="small" style="margin-left: 10px;">审核失败</el-tag>
                </el-row>
                <el-row v-if="proofInfo.proofAuditRemark" style="margin-bottom: 10px;">
                    <span style="font-weight: bold;">审核备注：</span>
                    <span style="margin-left: 10px;color: #606266;">{{ proofInfo.proofAuditRemark }}</span>
                </el-row>
                <el-row v-if="proofInfo.proofAuditTime && (proofInfo.proofAuditStatus == 1 || proofInfo.proofAuditStatus == 2)">
                    <span style="font-weight: bold;">审核时间：</span>
                    <span style="margin-left: 10px;color: #606266;">{{ proofInfo.proofAuditTime }}</span>
                </el-row>
            </div>
            <!-- 上传组件 -->
            <el-upload
                class="identity-upload"
                :action="uploadUrl"
                :headers="headers"
                :on-success="handleIdentityUploadSuccess"
                :on-error="handleIdentityUploadError"
                :on-remove="handleIdentityFileRemove"
                :before-upload="beforeIdentityUpload"
                :file-list="identityFileList"
                multiple>
                <el-button size="small" type="primary">选择文件</el-button>
                <div slot="tip" class="el-upload__tip" style="margin-top: 10px;color: #909399;">
                    支持上传图片、Word、PDF文件，文件大小不超过10MB，可上传多个文件
                </div>
            </el-upload>
            <!-- 显示已上传的文件内容 -->
            <div class="showImg" v-if="identityFileList && identityFileList.length > 0" style="margin-top: 20px;">
                <el-row :gutter="15">
                    <el-col :span="8" v-for="(file, index) in identityFileList" :key="file.uid || index" style="margin-bottom: 15px;">
                        <div style="border: 1px solid #e4e7ed;border-radius: 4px;padding: 10px;background-color: #ffffff;height: 100%;">
                            <!-- <div style="margin-bottom: 8px;font-weight: bold;color: #606266;border-bottom: 1px solid #e4e7ed;padding-bottom: 5px;font-size: 12px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;" :title="file.name">
                                <i class="el-icon-document" style="margin-right: 3px;font-size: 12px;"></i>{{ file.name }}
                            </div> -->
                            <!-- 图片显示 -->
                            <div v-if="$matchType(file.url || file.name) === 'image'" style="text-align: center;padding: 5px;">
                                <el-image
                                    :src="$isHttp(file.url)"
                                    style="width: 100%;height: 200px;border-radius: 4px;"
                                    fit="contain"
                                    :preview-src-list="[$isHttp(file.url)]">
                                </el-image>
                            </div>
                            <!-- Word文件显示 -->
                            <div v-else-if="$matchType(file.url || file.name) === 'word'" style="border-radius: 4px;background-color: #f5f7fa;padding: 0;height: 250px;overflow: hidden;">
                                <iframe
                                    :src="'https://forward.cj-edu.com?src=' + encodeURIComponent($isHttp(file.url))"
                                    style="width: 100%;height: 100%;border: none;"
                                    frameborder="0">
                                </iframe>
                            </div>
                            <!-- PDF文件显示 -->
                            <div v-else-if="$matchType(file.url || file.name) === 'pdf'" style="border-radius: 4px;background-color: #f5f7fa;padding: 0;height: 250px;overflow: hidden;">
                                <iframe
                                    :src="'../../static/pdf/web/viewer.html?file=' + encodeURIComponent($isHttp(file.url))"
                                    style="width: 100%;height: 100%;border: none;"
                                    frameborder="0">
                                </iframe>
                            </div>
                            <!-- 其他文件类型 -->
                            <div v-else style="padding: 15px;text-align: center;color: #909399;height: 200px;display: flex;flex-direction: column;justify-content: center;align-items: center;">
                                <i class="el-icon-document" style="font-size: 36px;display: block;margin-bottom: 8px;"></i>
                                <p style="font-size: 12px;margin-bottom: 5px;">该文件类型暂不支持预览</p>
                                <el-link :href="$isHttp(file.url)" target="_blank" type="primary" style="font-size: 12px;">下载查看</el-link>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="identityProofDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitIdentityDocument" :disabled="identityFileList.length === 0" :loading="identityUploadLoading">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { getCookieForRoleTag, getStudentInfoKeyForRoleTag } from "../../common/ulit";
import { ApiEncryption, isvalidPhone } from "../../common/validate";
import headImg from '@/images/user/headImg.png';
import newStudentFace from "@/components/newStudentFace";	//人脸识别
import filePng from '@/images/checkInMaterials/fileInfo.png';
import QRCode from 'qrcodejs2';
import android from '@/images/login/android_cj.png';
import singDiv from "@/components/singDiv"; //签名
import {
    getOnlinePrice,
    downloadPayList,
    getWeChatPayQRCode,
    getAliPayQRCode,
    createPayId,
    getPayList
} from "../../common/services";
import Cropper from '@/components/cropper/index';
export default {
    name: "StudentReport",
    components: {
        newStudentFace,
        Cropper,
        singDiv
    },
    data() {
        return {
            infoConfirmVisible: false,//确认信息有误弹窗
            imageUrl: android, // 上传图片地址
            cropOption: {  // 如果只是单组件使用的话，可以直接写在cropper组件中，这里是多组件使用，如：头像上传，广告上传，头像与广告的上传框宽高不一样，还有查看弹窗禁用上传功能等
                autoCropWidth: '',
                autoCropHeight: '',
                width: 448,
                deleteLeft: 230,
                updateLeft: 180,
                disabled: false
            },
            userInfo: {},
            submitBut: false,
            active: 0,
            yzmType: 2,
            headImg: headImg,
            studentPhotoUrl: "",
            uploadUrl: this.$baseUrl + "/api/file/update.do", //请求接口
            // headers: {token:this.$cookies.get("JT_S_02_token")}, //请求头
            headers: { token: getCookieForRoleTag(), "_role_tag": getCookieForRoleTag() ? getCookieForRoleTag().split(".")[getCookieForRoleTag().split(".").length - 1] : null }, //请求头
            dataInfo: {},
            visibleFaceModal: false,
            setUpInfo: {//新生报到个步骤是否显示
                studentNewPhotoOpenConfig: false,  //获取新生照片上传是否打开配置
                studentNewFaceOpenConfig: false, //获取新生人脸是否打开配置
                studentNewPayConfig: false,	//获取新生缴费是否开启
                studentNewDataOpenConfig: false,   //获取新生报到材料是否开启
                stuNewVerifyPhoneOpenConfig: false,   //是否开启短信验证
                studentNewDataAuditOpenConfig: false,   //材料审核
                studentNewVerifyPhoneShowConfig:1, //新生手机号验证显示位置 1:首页，也就是刚进来  2：报道流程，也就是人脸识别前面  3:同时存在
            },
            payStatusInfo: {
                payStatus: "",  //1已缴费  2未交费
                payMsg: ""    //如果是1已缴费的时候，你可以显示这里面的消息到缴费页面
            },
            flowMap: {}, //流程map
            showSteps: false, //是否显示步骤
            loading: null,
            nextButtonLoading: false, // next按钮loading状态
            nextButtonDisabled: false, // next按钮禁用状态
            studentPhotoInfo: {}, //新生照片对象
            showFace: 0, //识别过了返回1，没有则返回0
            attributeList: [], //报到材料补充
            attributeRelationMap: {}, //报到资料上传值map
            filePng: filePng,
            previewImgUrl: "",
            previewImgShow: false,
            showBut: 0, //显示保存或者确认无误 1：显示保存 2：显示确认无误 3:下一步
            studentConfirmStatus: 2, //是否确认资料无误（1是 2否）
            studentNewDataState: 2, //状态（1已审核 2未审核 3不通过）
            examineRemark: "", //审核备注
            reportStatus: 2,//1 已报到 2:未报到
            registrationTime: { //获取报到时间范围
                startTime: "",
                endTime: ""
            },
            // 支付
            pay_dialog: {
                visible: false,
                title: "选择支付方式",
                payType: "wechat",
                inner_dialog: {
                    imgSrc: "",
                    visible: false,
                    title: "微信支付",
                }
            },
            toBePaid: 0, //缴费金额
            payId: "",//支付订单号
            payStatusTimeout: null,
            totalIndex: 0, //流程总步骤
            descriptionMsg: "管理员未设置新生报到时间",
            getNowTime: "", //服务器时间

            //图片裁剪
            cropperShow: false,
            onDataTime: new Date().getTime(),
            onAttributeId: null, //当前选择剪切的图片位置id,  签名的位置

            visible_sign: false,

            // 短信验证相关
            smsForm: {
                studentName: "",
                studentIdCard: "",
                studentNo: "",
                studentPhone: "",
                yzm: ""
            },
            smsRules: {
                studentPhone: [
                    {required: true, validator: (rule, value, callback) => {
                        if (this.$isEmpty(value)) {
                            callback(new Error('请输入手机号码'));
                        } else if (!isvalidPhone(value)) {
                            callback(new Error('请输入正确的手机号码'));
                        } else {
                            callback();
                        }
                    }, trigger: 'blur'}
                ],
                yzm: [
                    {required: true, message: "请输入短信验证码", trigger: "change"}
                ]
            },
            phoneNeedSendSms: true,
            setCode: "发送验证码",
            time: 60, //短信验证码倒计时
            disabledBut: false,
            smsSubmitBut: false,
            smsVerifyStatus: 2, // 1：通过验证 2：待验证
            agreeCamera: false, // 是否同意开启摄像头

            // 人脸识别失败相关
            faceVerifyFailed: false, // 是否显示人脸识别失败界面
            faceFailInfo: {
                msg: '',
                similarity: '',
                originalImage: '',
                capturedImage: '', // 采集图像，使用 targetPhotoUrl 填充
                data: {}
            },
            // 上传身份证明相关
            identityProofDialogVisible: false, // 上传身份证明对话框显示状态
            identityDocumentExplain: '', // 身份证明说明内容
            identityFileList: [], // 上传的文件列表
            identityUploadLoading: false, // 上传加载状态
            // 身份证明审核信息
            proofInfo: {
                proofUploadStatus: 0, // 证明文件上传状态 0: 未上传 1: 已上传
                proofArr: '', // 身份证明文件列表
                proofAuditStatus: 0, // 身份证明文件审核状态 0: 未审核 1: 审核通过 2: 审核失败
                proofAuditRemark: '', // 身份证明文件审核备注
                proofAuditTime: '', // 身份证明文件审核时间
                proofAuditUserId: '' // 身份证明文件审核人ID
            }
        };
    },
    computed: {
        // 判断是否需要显示短信验证
        needShowSmsVerify() {
            // 如果人脸验证失败，优先显示失败界面，不显示短信验证
            if (this.faceVerifyFailed) {
                return false;
            }
            // 开启了短信验证 && 人脸识别未完成（showFace != 1） && 短信验证未通过
            return this.setUpInfo.stuNewVerifyPhoneOpenConfig
                && (this.setUpInfo.studentNewVerifyPhoneShowConfig == 2 || this.setUpInfo.studentNewVerifyPhoneShowConfig == 3)
                && this.showFace != 1
                && this.smsVerifyStatus != 1;
        }
    },
    created() {
        this.getRegistrationTime();

    },
    methods: {
        payDialogClick() {
            // 判断当前时间如果不在 registrationTime.startTime , registrationTime.endTime 之间，提示未开放报到
            let nowTime = new Date().getTime();
            let startTime = new Date(this.registrationTime.startTime).getTime();
            let endTime = new Date(this.registrationTime.endTime).getTime();
            if (nowTime < startTime || nowTime > endTime) {
                this.$message({
                    message: '报到时间还未开始',
                    type: 'warning'
                });
            } else {
                this.pay_dialog.visible = true;
            }



        },
        getPropsUrl(data) { //传图片地址回来
            this.attributeRelationMap[this.onAttributeId] = data;
            this.attributeRelationMap = Object.assign({}, this.attributeRelationMap);
            if (this.showBut == 2) {
                this.saveStudentNewData();
            }
        },
        changePayType(type = 'wechat') {
            this.pay_dialog.payType = type;
            this.pay_dialog.inner_dialog.imgSrc = "";
        },
        getWeChatQrcode(text) {
            this.$refs.qrcode.innerHTML = "";
            return new QRCode('qrcode', {
                width: 200, // 设置宽度，单位像素
                height: 200, // 设置高度，单位像素
                text,   // 设置二维码内容或跳转地址
            })

        },
        async goPay() {
            const originDialog = this.pay_dialog;
            const originInnerDialog = originDialog.inner_dialog;
            const payType = originDialog.payType;
            this.pay_dialog.inner_dialog = {
                ...originInnerDialog,
                visible: true,
                title: payType === 'wechat' ? '微信支付' : '支付宝支付'
            }
            const imgPath = await this.getPayQRCode(payType);
            console.log('获取到的图片地址', imgPath);
            this.pay_dialog.inner_dialog.imgSrc = imgPath;
        },
        async getPayQRCode(type = 'wechat') {
            //支付宝直接获取地址展示，微信获取到之后要将文本转成二维码
            const fn = type === 'wechat' ? getWeChatPayQRCode : getAliPayQRCode;
            const res = await fn(this.payId);
            //区分微信、支付宝
            if (type == 'wechat') {
                const prefix = window.configs.API_ROOT;
                // let obj = {
                //     baseUrl: prefix,
                //     orderNo: this.payId,
                //     studentId: this.userInfo.studentId,
                //     studentName: this.userInfo.studentName,
                //     studentIdCard: this.userInfo.studentIdCard,
                //     studentNo: this.userInfo.studentNo,
                //     studentTestNo: this.userInfo.studentTestNo,
                //     professionalName: this.userInfo.professionalName,
                //     toBePaid: this.toBePaid,
                //     deviceType:'PC',
                // }
                let obj = {
                    price: this.toBePaid,
                    baseUrl: prefix,
                    payId: this.payId,
                    studentId: this.userInfo.studentId
                }
                const params = JSON.stringify(obj)
                const imgPath = this.getWeChatQrcode(`${prefix}/api/student/wxLogin.do?params=${params}`);
                console.log(imgPath)
                return "";
            } else {
                return res.data;
            }
        },
        getRegistrationTime() { //获取报到时间范围
            this.$store.dispatch("user/getRegistrationTime").then((ret) => {
                if (ret.code == 0) {
                    this.registrationTime = ret.data;
                    if (!this.$isEmpty(ret.data) && !this.$isEmpty(this.registrationTime.startTime) && !this.$isEmpty(this.registrationTime.endTime)) {
                        this.getStudentReportFlowConfig();
                        this.getNowDate();
                    }
                }
            }).catch((res) => {

            });
        },
        getReportStatus() { //获取报道状态
            this.$store.dispatch("user/getReportStatus").then((ret) => {
                if (ret.code == 0) {
                    this.reportStatus = ret.data;//1 已报到 2:未报到
                    if (this.reportStatus == 1) {
                        this.active = this.totalIndex;
                    } else {
                        this.getStudentNewInfo();
                        if (this.setUpInfo.studentNewPayConfig) { //新生缴费是否开启
                            this.getStudentPayStatus();

                            this.payStatusTimeout = setInterval(() => { //轮训获取支付状态。
                                this.getPayStatusTimeout();
                            }, 3500);
                        }
                    }

                }
            }).catch(() => {

            });
        },
        getStudentReportFlowConfig() { //获取新生报到各个流程的开关配置
            this.loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.$store.dispatch("user/getStudentReportFlowConfig").then((ret) => {
                if (ret.code == 0) {
                    this.setUpInfo = ret.data;
                    this.totalIndex = 0;
                    for (let i = 0; i < Object.keys(this.setUpInfo).length; i++) {
                        if (i == 0 && this.setUpInfo.studentNewPayConfig) {
                            this.flowMap[this.totalIndex] = "payConfig";
                            this.totalIndex++;
                            this.flowMap[this.totalIndex] = "confirmConfig";
                            this.totalIndex++;
                        } else if (i == 0 && !this.setUpInfo.studentNewPayConfig) {
                            this.flowMap[this.totalIndex] = "confirmConfig";
                            this.totalIndex++;
                        }

                        if (i == 1 && this.setUpInfo.studentNewPhotoOpenConfig) {
                            this.flowMap[this.totalIndex] = "dataOpenConfig";
                            this.totalIndex++;
                        } else if (i == 2 && this.setUpInfo.studentNewFaceOpenConfig) {
                            this.flowMap[this.totalIndex] = "faceOpenConfig";
                            this.totalIndex++;
                        } else if (i == 3 && this.setUpInfo.studentNewDataOpenConfig) {
                            this.flowMap[this.totalIndex] = "photoOpenConfig";
                            this.totalIndex++;
                        } else if (i == 4 && this.setUpInfo.studentNewDataAuditOpenConfig) { //材料审核
                            this.flowMap[this.totalIndex] = "auditPhotoOpenConfig";
                            this.totalIndex++;
                        }
                    }
                    this.flowMap[this.totalIndex] = "complete";
                    this.showSteps = true;
                    this.loading.close();
                    this.getReportStatus();
                } else {
                    this.loading.close();
                }
            }).catch(() => {
                this.loading.close();
            });
        },
        getStudentPayStatus() { //获取缴费状态
            this.$store.dispatch("user/getStudentPayStatus").then((ret) => {
                this.loading.close();
                if (ret.code == 0) {
                    this.payStatusInfo = ret.data;
                    if (this.payStatusInfo.payStatus == 2) { //1已缴费  2未交费
                        if (this.payStatusInfo.payType == 1) { //1:在线缴费 2：线下本地缴费
                            this.getPayAmount();

                            createPayId().then(res => { //未交费，获取支付订单号
                                this.payId = res.data;
                            });
                        }
                    } else {
                        if (this.payStatusTimeout != null) { //停止支付状态轮训
                            clearInterval(this.payStatusTimeout);
                        }
                    }
                }
            }).catch(() => {
                this.loading.close();
            });
        },
        getPayStatusTimeout() { //用于轮训查询缴费状态
            this.$store.dispatch("user/getStudentPayStatus").then((ret) => {
                if (ret.code == 0) {
                    this.payStatusInfo = ret.data;
                    if (this.payStatusInfo.payStatus == 1 && this.payStatusTimeout != null) { //1已缴费  2未交费
                        this.pay_dialog.visible = false;
                        this.pay_dialog.inner_dialog.visible = false;
                        clearInterval(this.payStatusTimeout);
                    }
                }
            }).catch(() => {

            });
        },
        getPayAmount() { //显示缴费金额
            this.$store.dispatch("user/getPayAmount").then((ret) => {
                this.loading.close();
                if (ret.code == 0) {
                    this.toBePaid = ret.data;
                }
            }).catch(() => {
                this.loading.close();
            });
        },
        getStudentNewInfo() { //获取新生信息【个人信息确认】
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.$store.dispatch("user/getStudentNewInfo").then((ret) => {
                loading.close();
                if (ret.code == 0) {
                    this.userInfo = ret.data;
                } else {
                    this.$message({
                        message: ret.msg,
                        type: 'warning'
                    });
                }
            }).catch(() => {
                loading.close();
            });
        },
        getStudentNewPhoto() { //获取新生照片信息
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.$store.dispatch("user/getStudentNewPhoto").then((ret) => {
                loading.close();
                if (ret.code == 0) {
                    this.studentPhotoInfo = ret.studentPhoto || {};
                    if (!this.$isEmpty(ret.studentPhoto.studentPhotoUrl)) {
                        this.headImg = this.$isHttp(ret.studentPhoto.studentPhotoUrl);
                        this.studentPhotoUrl = ret.studentPhoto.studentPhotoUrl;
                    }
                    this.studentPhotoInfo = Object.assign({}, this.studentPhotoInfo);
                } else {
                    this.$message({ message: ret.msg, type: 'warning' });
                }
            }).catch(() => {
                loading.close();
            });
        },
        addStudentNewPhoto() { //保存上传学生图片
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.$store.dispatch("user/addStudentNewPhoto", { studentPhotoUrl: this.studentPhotoUrl }).then((ret) => {
                loading.close();
                if (ret.code == 0) {
                    this.studentPhotoInfo.studentPhotoState = 2;// 1已审核 2未审核 3不通过
                    this.studentPhotoInfo = Object.assign({}, this.studentPhotoInfo);
                } else {
                    this.$message({ message: ret.msg, type: 'warning' });
                }
            }).catch(() => {
                loading.close();
            });
        },
        confirmStudentNewPhoto() { //确认无误
            if (!this.getTimeRegion()) {
                return;
            }
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.$store.dispatch("user/confirmStudentNewPhoto").then((ret) => {
                loading.close();
                if (ret.code == 0) {
                    this.studentPhotoInfo.studentPhotoConfirm = 1;//是否确认照片无误（1是 2否）
                    this.$message.success("确认成功！");
                    this.studentPhotoInfo = Object.assign({}, this.studentPhotoInfo);
                    this.getStudentNewPhoto();
                } else {
                    this.$message({ message: ret.msg, type: 'warning' });
                }
            }).catch(() => {
                loading.close();
            });
        },
        getStudentNewFaceInfo() { //获取新生人脸识别状态，识别过了返回1，没有则返回0
            // 首先检查是否上传了身份证明
            this.$store.dispatch("user/getStudentNewProof").then((proofRet) => {
                if (proofRet.code == 0 && proofRet.data && proofRet.data.proofUploadStatus == 1) {
                    // 保存身份证明信息
                    this.proofInfo = {
                        proofUploadStatus: proofRet.data.proofUploadStatus || 0,
                        proofArr: proofRet.data.proofArr || '',
                        proofAuditStatus: proofRet.data.proofAuditStatus || 0,
                        proofAuditRemark: proofRet.data.proofAuditRemark || '',
                        proofAuditTime: proofRet.data.proofAuditTime || '',
                        proofAuditUserId: proofRet.data.proofAuditUserId || ''
                    };

                    // 如果身份证明审核通过（proofAuditStatus == 1），显示"已通过人脸识别"
                    if (proofRet.data.proofAuditStatus == 1) {
                        this.showFace = 1;
                        this.faceVerifyFailed = false;
                    } else {
                        // 如果审核未通过或未审核，显示失败界面
                        this.faceVerifyFailed = true;
                        // 填充失败信息（如果没有匹配度和采集图像，使用默认值）
                        this.faceFailInfo = {
                            msg: proofRet.data.proofAuditStatus == 2 ? '身份证明审核失败' : '已上传身份证明，等待审核',
                            similarity: proofRet.data.similarity || '', // 如果有相似度数据
                            originalImage: proofRet.data.originalImage || this.headImg, // 录取照片
                            capturedImage: proofRet.data.targetPhotoUrl || '', // 采集图像（targetPhotoUrl）
                            data: proofRet.data || {}
                        };
                    }
                } else {
                    // 如果没有上传身份证明，正常获取人脸识别状态
                    const loading = this.$loading({
                        lock: true,
                        text: 'Loading',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    this.$store.dispatch("user/getStudentNewFaceInfo").then((ret) => {
                        loading.close();
                        if (ret.code == 0) { //识别过了返回1，没有则返回0
                            this.showFace = ret.data;
                            if (ret.data == 0) {
                                this.visibleFaceModal = true;
                            }
                        } else {
                            this.$message({ message: ret.msg, type: 'warning' });
                        }
                    }).catch(() => {
                        loading.close();
                    });
                }
            }).catch(() => {
                // 如果获取身份证明失败，正常获取人脸识别状态
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                this.$store.dispatch("user/getStudentNewFaceInfo").then((ret) => {
                    loading.close();
                    if (ret.code == 0) { //识别过了返回1，没有则返回0
                        this.showFace = ret.data;
                        if (ret.data == 0) {
                            this.visibleFaceModal = true;
                        }
                    } else {
                        this.$message({ message: ret.msg, type: 'warning' });
                    }
                }).catch(() => {
                    loading.close();
                });
            });
        },
        successFace() {
            this.showFace = 1;
            this.faceVerifyFailed = false; // 成功后隐藏失败界面
        },
        handleFaceFailed(failInfo) {
            // 处理人脸识别失败
            this.faceVerifyFailed = true;
            // 从多个可能的位置获取相似度：failInfo.data.similarity、failInfo.similarity 或从 msg 中提取
            let similarity = '';
            if (failInfo.data && failInfo.data.similarity !== undefined && failInfo.data.similarity !== null) {
                similarity = failInfo.data.similarity;
            } else if (failInfo.similarity !== undefined && failInfo.similarity !== null) {
                similarity = failInfo.similarity;
            } else {
                similarity = this.extractSimilarityFromMsg(failInfo.msg);
            }
            this.faceFailInfo = {
                msg: failInfo.msg || '',
                similarity: similarity,
                originalImage: (failInfo.data && failInfo.data.originalImage) || failInfo.originalImage || this.headImg,
                capturedImage: failInfo.targetPhotoUrl || failInfo.capturedImage || '', // 采集图像（使用targetPhotoUrl）
                data: failInfo.data || {}
            };
        },
        extractSimilarityFromMsg(msg) {
            // 从msg中提取相似度数值
            if (!msg) return '';
            // 匹配"人脸相似度低于85.0"中的85.0，支持多种格式
            const patterns = [
                /人脸相似度低于([\d.]+)/,
                /相似度[为是]([\d.]+)/,
                /([\d.]+)%/
            ];
            for (let pattern of patterns) {
                const match = msg.match(pattern);
                if (match && match[1]) {
                    return match[1];
                }
            }
            return '';
        },
        reVerifyFace() {
            // 重新核验
            this.faceVerifyFailed = false;
            this.visibleFaceModal = true;
        },
        uploadIdentityProof() {
            // 上传身份证明
            this.identityProofDialogVisible = true;
            this.identityFileList = [];
            // 获取说明内容
            this.getIdentityDocumentExplain();
            // 获取已上传的文件列表
            this.getStudentNewProof();
        },
        getStudentNewProof() {
            // 获取身份证明文件列表
            this.$store.dispatch("user/getStudentNewProof").then((ret) => {
                if (ret.code == 0 && ret.data) {
                    this.proofInfo = {
                        proofUploadStatus: ret.data.proofUploadStatus || 0,
                        proofArr: ret.data.proofArr || '',
                        proofAuditStatus: ret.data.proofAuditStatus || 0,
                        proofAuditRemark: ret.data.proofAuditRemark || '',
                        proofAuditTime: ret.data.proofAuditTime || '',
                        proofAuditUserId: ret.data.proofAuditUserId || ''
                    };
                    // 如果身份证明审核通过，设置 showFace = 1
                    if (ret.data.proofAuditStatus == 1) {
                        this.showFace = 1;
                        this.faceVerifyFailed = false;
                    }

                    // 解析文件列表并反显
                    if (this.proofInfo.proofUploadStatus == 1 && this.proofInfo.proofArr) {
                        try {
                            // 尝试解析为JSON数组
                            let fileUrlList = [];
                            if (typeof this.proofInfo.proofArr === 'string') {
                                // 尝试解析JSON
                                try {
                                    fileUrlList = JSON.parse(this.proofInfo.proofArr);
                                } catch (e) {
                                    // 如果不是JSON，可能是逗号分隔的字符串
                                    fileUrlList = this.proofInfo.proofArr.split(',').filter(url => url.trim());
                                }
                            } else if (Array.isArray(this.proofInfo.proofArr)) {
                                fileUrlList = this.proofInfo.proofArr;
                            }
                            // 将URL列表转换为文件列表格式
                            this.identityFileList = fileUrlList.map((url, index) => {
                                // 从URL中提取文件名
                                const fileName = url.substring(url.lastIndexOf('/') + 1) || `文件${index + 1}`;
                                return {
                                    name: fileName,
                                    url: url.trim(),
                                    uid: Date.now() + index // 生成唯一ID
                                };
                            });
                        } catch (e) {
                            console.error('解析文件列表失败:', e);
                        }
                    }
                } else {
                    // 如果没有数据或获取失败，清空列表
                    this.identityFileList = [];
                }
            }).catch(() => {
                this.identityFileList = [];
            });
        },
        getIdentityDocumentExplain() {
            // 获取身份证明说明
            this.$store.dispatch("user/getIdentityDocumentExplain").then((ret) => {
                if (ret.code == 0) {
                    this.identityDocumentExplain = ret.data || '';
                } else {
                    this.$message.warning(ret.msg || '获取说明失败');
                }
            }).catch(() => {
                this.$message.error('获取说明失败');
            });
        },
        beforeIdentityUpload(file) {
            // 上传前验证
            const fileName = file.name;
            const fileExtension = fileName.substring(fileName.lastIndexOf('.') + 1).toLowerCase();
            const allowedExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'pdf', 'doc', 'docx'];

            if (!allowedExtensions.includes(fileExtension)) {
                this.$message.error('文件类型不支持！请上传图片、Word或PDF文件');
                return false;
            }

            const isLt10M = file.size / 1024 / 1024 < 10;
            if (!isLt10M) {
                this.$message.error('上传文件大小不能超过 10MB!');
                return false;
            }

            return true;
        },
        handleIdentityUploadSuccess(res, file) {
            // 上传成功回调
            if (res.code == 0) {
                // 将新上传的文件追加到列表中
                this.identityFileList.push({
                    name: res.data.nameFormat || file.name,
                    url: res.data.url,
                    uid: file.uid
                });
                this.$message.success('文件上传成功！');
            } else {
                this.$message.error(res.msg || '上传失败');
            }
        },
        handleIdentityUploadError(err, file, fileList) {
            // 上传失败回调
            this.$message.error('文件上传失败，请重试');
        },
        handleIdentityFileRemove(file, fileList) {
            // 移除文件
            this.identityFileList = fileList;
        },
        submitIdentityDocument() {
            // 提交身份证明
            if (this.identityFileList.length === 0) {
                this.$message.warning('请先上传文件');
                return;
            }

            // 收集所有文件的URL，组成数组
            const proofList = this.identityFileList.map(file => file.url).filter(url => url);

            if (proofList.length === 0) {
                this.$message.warning('请先上传文件');
                return;
            }

            this.identityUploadLoading = true;
            this.$store.dispatch("user/saveStudentNewProof", proofList).then((ret) => {
                this.identityUploadLoading = false;
                if (ret.code == 0) {
                    this.$message.success('身份证明上传成功！');
                    this.identityProofDialogVisible = false;
                    this.identityFileList = [];
                    // 上传成功后，可以重新获取人脸识别状态
                    // this.getStudentNewFaceInfo();
                } else {
                    this.$message.error(ret.msg || '上传失败');
                }
            }).catch(() => {
                this.identityUploadLoading = false;
                this.$message.error('上传失败');
            });
        },
        getStudentNewDataNew(tag) { //获取报到材料字段以及确认状态，填写情况
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.$store.dispatch("user/getStudentNewData").then((ret) => {
                loading.close();
                if (ret.code == 0) {
                    this.attributeList = ret.data.attributeList || [];
                    this.showBut = 1;
                    for (let i in this.attributeList) {
                        if (!this.$isEmpty(this.attributeList[i].attributeRelation)) {
                            this.showBut = 2;
                        }
                        let attributeRelation = this.attributeList[i].attributeRelation;
                        if (attributeRelation != null) {
                            this.attributeRelationMap[this.attributeList[i].attributeId] = attributeRelation.value;
                        } else {
                            this.attributeRelationMap[this.attributeList[i].attributeId] = "";
                        }
                    }
                    if (ret.data.studentConfirmStatus == 1) { //是否确认资料无误（1是 2否）
                        this.showBut = 3;
                    }
                    this.studentConfirmStatus = ret.data.studentConfirmStatus;//是否确认资料无误（1是 2否）
                    this.studentNewDataState = ret.data.studentNewDataState;//状态（1已审核 2未审核 3不通过）
                    if (this.studentNewDataState == 3) {
                        this.showBut = 3;
                    }
                    this.examineRemark = ret.data.examineRemark;//审核备注
                    this.attributeRelationMap = Object.assign({}, this.attributeRelationMap);
                    if (tag == 'cxsc') {
                        this.showBut = 2;
                    }
                } else {
                    this.$message({ message: ret.msg, type: 'warning' });
                }
            }).catch(() => {
                loading.close();
            });
        },
        handleAvatarSuccess(res, file) { //上传成功回调
            this.studentPhotoUrl = res.data.url; //准考证照片
            this.headImg = this.$baseUrl + res.data.url;
            this.addStudentNewPhoto();
        },
        beforeAvatarUpload(file) {
            if (!this.getTimeRegion()) {
                return false;
            }
            const isJPG = file.type === 'image/jpeg';
            const isPNG = file.type === 'image/png';
            const isLt5M = file.size / 1024 / 1024 <= 10;

            if (!isJPG && !isPNG) {
                this.$message.error('上传头像图片只能是 JPG/PNG 格式!');
                return false;
            }
            if (!isLt5M) {
                this.$message.error('上传头像图片大小不能超过 10MB!');
                return false;
            }
            return (isJPG || isPNG) && isLt5M;
        },
        attributeSuccess(item, res, file) { //上传成功回调 【报到资料】
            // this.headImg = this.$baseUrl + res.data.url;
            this.attributeRelationMap[item.attributeId] = res.data.url; //写入map
            this.attributeRelationMap = Object.assign({}, this.attributeRelationMap);
            if (this.showBut == 2) {
                this.saveStudentNewData();
            }
        },
        saveStudentNewData(tag) { //保存新生报到材料
            if (!this.getTimeRegion()) {
                return;
            }
            let attributeRelationList = [], status = false, msg = "";
            for (let i in this.attributeList) {
                if (this.attributeList[i].notNullStatus == 1 && this.$isEmpty(this.attributeRelationMap[this.attributeList[i].attributeId])) { //是否必填 1是 2否
                    status = true;
                    msg = "请上传" + this.attributeList[i].attributeName + "！";
                    break;
                }
            }
            if (status) {
                this.$message.warning(msg);
                return;
            }
            for (let key in this.attributeRelationMap) {
                attributeRelationList.push({
                    attributeIds: key,
                    value: this.attributeRelationMap[key],
                });
            }
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.$store.dispatch("user/saveStudentNewData", { attributeRelationList: attributeRelationList }).then((ret) => {
                loading.close();
                if (tag == 'qrwu') {
                    this.confirmStudentNewData();
                } else {
                    if (ret.code == 0) {
                        this.$message.success("提交成功！");
                        this.showBut = 2;
                    } else {
                        this.$message({ message: ret.msg, type: 'warning' });
                    }
                }

            }).catch(() => {
                loading.close();
            });
        },
        confirmStudentNewData() { //确认报到材料无误
            if (!this.getTimeRegion()) {
                return;
            }
            this.$confirm('是否确认报到材料无误?确认后将无法修改', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                this.$store.dispatch("user/confirmStudentNewData").then((ret) => {
                    loading.close();
                    if (ret.code == 0) {
                        this.$message.success("材料确定成功！");
                        this.studentNewDataState == 2;
                        this.studentConfirmStatus == 1;
                        this.showBut = 3;
                    } else {
                        this.$message({ message: ret.msg, type: 'warning' });
                    }
                }).catch(() => {
                    loading.close();
                });
            }).catch(() => {

            });
        },
        next() {
            // 防止重复点击：如果正在加载或禁用状态，则直接返回
            if (this.nextButtonLoading || this.nextButtonDisabled) {
                return;
            }

            // 设置按钮状态为加载中
            this.nextButtonLoading = true;
            this.nextButtonDisabled = true;
            try {
                if (this.active++ > 7) {
                    this.active = 0;
                };
                // if(this.flowMap[this.active] == 'confirmConfig'){ //确认信息
                //     this.getStudentNewInfo();
                // }
                if (this.flowMap[this.active] == 'dataOpenConfig') { //照片上传
                    this.getStudentNewPhoto();
                }
                if (this.flowMap[this.active] == 'faceOpenConfig') { //人脸识别
                    if(this.studentPhotoInfo == null || Object.keys(this.studentPhotoInfo).length <= 0){
                        this.getStudentNewPhoto();
                    }
                    // 如果开启了短信验证，先获取短信验证数据
                    if (this.setUpInfo.stuNewVerifyPhoneOpenConfig) {
                        this.getStudentVerifyData();
                    } else {
                        this.getStudentNewFaceInfo();
                    }
                }
                if (this.flowMap[this.active] == 'photoOpenConfig') { //报到材料补充
                    this.getStudentNewDataNew();
                }
                if (this.flowMap[this.active] == 'auditPhotoOpenConfig') { //报到材料审核状态
                    this.getStudentNewDataNew();
                }
            } catch (error) {
                // 发生错误时也要恢复按钮状态
                this.nextButtonLoading = false;
                this.nextButtonDisabled = false;
                throw error;
            }

            // 2秒后解除禁用状态
            setTimeout(() => {
                this.nextButtonLoading = false;
                this.nextButtonDisabled = false;
            }, 2000);
        },
        previousStep() { //重新上传
            this.active = this.active - 1;
            this.getStudentNewDataNew('cxsc');
        },
        previewImg(url) { //预览
            this.previewImgShow = true;
            this.previewImgUrl = url;
        },
        handleClose() {
            this.previewImgShow = false;
        },
        confirmReport() { //确认报到
            if (!this.getTimeRegion()) {
                return;
            }
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.$store.dispatch("user/confirmReport").then((ret) => {
                loading.close();
                if (ret.code == 0) {
                    this.$message.success("报到完成！");
                    this.getReportStatus();
                } else {
                    this.$message({ message: ret.msg, type: 'warning' });
                }
            }).catch(() => {
                loading.close();
            });
        },
        infoConfirm() {
            if (!this.getTimeRegion()) {
                return;
            }
            this.infoConfirmVisible = true
        },
        submitInfo(sign, tag) {
            if (!this.getTimeRegion()) {
                return;
            }
            this.submitBut = true;
            let param = {
                studentNewId: this.userInfo.studentNewId,
                studentConfirm: sign //1确认无误，2未确认
            }
            this.$store.dispatch("user/confirmStudentNewInfo", param)
                .then((ret) => {
                    this.submitBut = false;
                    if (ret.code == 0) {
                        this.userInfo.studentConfirm = sign;
                        this.infoConfirmVisible = false
                        if (tag == 'xyb') {
                            this.next();
                        } else {
                            this.$message({ message: ret.msg, type: ret.code == 0 ? 'success' : 'warning' });
                        }
                    }
                }).catch(() => {
                    this.submitBut = false;
                });
        },
        getTimeRegion(mes) { //判断当前时间是否是可报到时间段
            if (!this.$isEmpty(this.registrationTime.startTime) && !this.$isEmpty(this.registrationTime.endTime)) {
                if (this.$compareTime(this.getNowTime, this.registrationTime.startTime)) {
                    if (mes != 1) {
                        this.$message.error("报到时间还未开始");
                    }
                    return false;
                } else if (this.$compareTime(this.registrationTime.endTime, this.getNowTime)) {
                    if (mes != 1) {
                        this.$message.error("报到时间已结束");
                    }
                    return false;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        },
        getNowDate() {
            this.$store.dispatch("getNowTime").then((res) => {
                if (res.code == 0) {
                    this.getNowTime = res.data;
                }
            })
        },
        cropper_cj(url, id) { //裁剪图片
            this.onDataTime = new Date().getTime()
            this.cropperShow = true;
            this.imageUrl = this.$isHttp(url);
            this.onAttributeId = id;
        },
        singShow(url, id) {
            this.onAttributeId = id;
            this.visible_sign = true;
        },
        closeMsg() {
            this.visible_sign = false;
        },
        saveSignValue(data) { //签名的url地址
            this.attributeRelationMap[this.onAttributeId] = data;
            this.attributeRelationMap = Object.assign({}, this.attributeRelationMap);
            if (this.showBut == 2) {
                this.saveStudentNewData();
            }
        },
        // 短信验证相关方法
        getVerifyStudentPhoneNeedSendSms() { //是否需要验证码才能确定
            this.$store.dispatch("user/getVerifyStudentPhoneNeedSendSms", {verifyCodeEnum: "STUDENT_NEW"}).then((ret) => {
                if (ret.code == 0) { // true：显示 false不显示
                    this.phoneNeedSendSms = ret.data;
                }
            }).catch((ret) => {
            });
        },
        getVerifyCodeIntervalTime() { //获取短信验证码发送冷却时间
            this.$store.dispatch("user/getVerifyCodeIntervalTime", {verifyCodeEnum: "STUDENT_NEW"}).then((ret) => {
                if (ret.code == 0) {
                    this.time = ret.data / 1000 || 60;
                }
            }).catch((ret) => {
            });
        },
        getStudentVerifyData() { //开启验证，获取学生手机号验证数据
            this.$store.dispatch("user/getStudentVerifyData", {verifyCodeEnum: "STUDENT_NEW"}).then((ret) => {
                if (ret.code == 0 && ret.data) {
                    this.smsForm.studentName = ret.data.studentName || this.userInfo.studentName || "";
                    this.smsForm.studentIdCard = ret.data.studentIdCard || this.userInfo.studentIdCard || "";
                    this.smsForm.studentNo = ret.data.studentNo || this.userInfo.studentNo || "";
                    this.smsForm.studentPhone = ret.data.studentPhone || "";
                    // this.smsVerifyStatus = ret.data.verifyStatus || 2; // 1：通过验证 2：待验证
                    this.smsVerifyStatus = 2; // 1：通过验证 2：待验证
                    if (this.smsVerifyStatus == 1) {
                        // 已通过验证，获取人脸识别信息
                        this.getStudentNewFaceInfo();
                    } else {
                        // 待验证，初始化表单
                        this.getVerifyCodeIntervalTime();
                        this.getVerifyStudentPhoneNeedSendSms();
                        // 上传成功后，可以重新获取人脸识别状态
                        this.getStudentNewFaceInfo();
                    }
                } else {
                    // 如果没有验证数据，使用用户信息填充
                    this.smsForm.studentName = this.userInfo.studentName || "";
                    this.smsForm.studentIdCard = this.userInfo.studentIdCard || "";
                    this.smsForm.studentNo = this.userInfo.studentNo || "";
                    this.getVerifyCodeIntervalTime();
                    this.getVerifyStudentPhoneNeedSendSms();
                }
            }).catch((ret) => {
                // 出错时使用用户信息填充
                this.smsForm.studentName = this.userInfo.studentName || "";
                this.smsForm.studentIdCard = this.userInfo.studentIdCard || "";
                this.smsForm.studentNo = this.userInfo.studentNo || "";
                this.getVerifyCodeIntervalTime();
                this.getVerifyStudentPhoneNeedSendSms();
            });
        },
        getYzm() { // 获取短信验证码
            if (this.$isEmpty(this.smsForm.studentPhone)) {
                this.$message.warning('请输入手机号！');
                return;
            }
            //后台需传入的参数
            let data = {
                phone: this.smsForm.studentPhone,
                verifyCodeEnum: "STUDENT_NEW"
            };
            let url = "/api/student/" + ApiEncryption() + "/sendVerifyCode.do";
            this.$post(this.$baseUrl + url, data).then((ret) => {
                if (ret.code == 0) {
                    this.$message.success('发送成功！');
                    this.validateBtn();
                } else {
                    this.$message.error(ret.msg);
                }
            });
        },
        validateBtn() {
            //倒计时
            let time = this.time;
            this.disabledBut = true;
            let timer = setInterval(() => {
                if (time == 0) {
                    clearInterval(timer);
                    this.disabledBut = false;
                    this.setCode = "发送验证码";
                } else {
                    this.setCode = time + "秒后重试";
                    this.disabledBut = true;
                    time--;
                }
            }, 1000);
        },
        submitSmsInfo() { //提交短信验证
            // this.$message.success('确认成功！');
            // this.smsVerifyStatus = 1; // 通过验证
            // // 短信验证通过后，直接打开人脸识别
            // this.visibleFaceModal = true;
            // // this.getStudentNewFaceInfo();
            // this.faceVerifyFailed = false;
            this.$refs['smsForm'].validate((valid) => {
                if (valid) {
                    this.smsSubmitBut = true;
                    let param = {
                        verifyCodeEnum: "STUDENT_NEW",
                        phone: this.smsForm.studentPhone,
                        code: this.smsForm.yzm
                    };
                    this.$store.dispatch("user/verifyStudentPhone", param).then((ret) => {
                        this.smsSubmitBut = false;
                        if (ret.code == 0) {
                            this.$message.success('确认成功！');
                            localStorage.setItem('smsVerifyStatus',1); //短信验证通过，直接进入人脸识别
                            this.smsVerifyStatus = 1; // 通过验证
                            // 短信验证通过后，直接打开人脸识别
                            this.visibleFaceModal = true;
                            // this.getStudentNewFaceInfo();
                            this.faceVerifyFailed = false;
                        } else {
                            this.$message.error(ret.msg);
                        }
                    }).catch((ret) => {
                        this.smsSubmitBut = false;
                    });
                } else {
                    return false;
                }
            });
        }
    },
    beforeDestroy() { //销毁前执行
        if (this.payStatusTimeout != null) { //停止支付状态轮训
            clearInterval(this.payStatusTimeout);
        }
    }
};
</script>
<style lang="less">
@import '../../styles/base.less';

.infoConfirmText {
    text-align: center;
}

.el-studentReport {
    .identity-upload{
        .el-upload-list{
            display: none;
        }
    }
    .page_content {
        padding: 0 20px 20px;
    }

    .el-descriptions-item__label {
        white-space: nowrap;
        width: 80px;
        text-align: right;
        padding-top: 10px;
    }

    .el-descriptions-item__container {
        font-size: 15px;
    }

    .el-descriptions-item__content {
        width: 70%;
        border-bottom: 1px solid #b0b0b0;
        padding: 10px 0 5px 10px;
        font-weight: 600;
    }

    .el-descriptions {
        padding-left: 35px;
    }

    .lxdz {
        .el-descriptions-item__content {
            width: 60%;
        }
    }

    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar {
        width: 144px;
        height: 192px;
        display: block;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 144px;
        height: 192px;
        line-height: 192px;
        text-align: center;
    }

    .el-step__head.is-process,
    .el-step__title.is-process {
        color: orange;
        border-color: orange;
    }

    .title_l {
        float: left;
        margin-right: 20px;
        width: 240px;
        text-align: right;
    }

    .attrList-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 200px;
        height: 100px;
        line-height: 100px;
        text-align: center;
    }

    .attrList_avatar {
        width: 200px;
        height: 100px;
        display: block;
    }

    .previewImg {
        .el-dialog__header {
            display: none;
        }

        .el-dialog__body {
            padding: 0;
        }

        .el-dialog__footer {
            display: none;
        }
    }

    .payDialog {
        .spanTitle {
            display: inline-block;
            width: 75px;
            text-align: right;
        }

        .el-col {
            line-height: 3em;

            span {
                &.money {
                    color: red;
                }

                &:nth-child(2) {
                    margin-left: 2em;
                }
            }

            .typeBox {
                span {
                    line-height: 50px;
                    vertical-align: top;
                    display: inline-block;
                }

                img {
                    margin-left: 2em;
                    padding: 10px;
                    border: 1px solid transparent;

                    &.selected {
                        border-color: lightgrey;
                        box-shadow: 0 0 1px grey inset;
                        border-radius: 10px;
                    }

                }
            }

        }

        p.tip {
            margin-bottom: 3em;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/studentReport.vue